var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrustpilot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.893 8.192h-8.034L10.466.5 7.902 8.192H.038l6.325 4.616L3.97 20.5l6.496-4.786L16.79 20.5l-2.394-7.692 6.496-4.616z",
    fill: "#555249"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91 14.517l-.514-1.71-3.931 2.907 4.444-1.197z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjg5MyA4LjE5MjMxSDEyLjg1ODhMMTAuNDY1NyAwLjVMNy45MDE1OCA4LjE5MjMxSDAuMDM4MzMwMUw2LjM2MzEyIDEyLjgwNzdMMy45Njk5NSAyMC41TDEwLjQ2NTcgMTUuNzEzN0wxNi43OTA1IDIwLjVMMTQuMzk3MyAxMi44MDc3TDIwLjg5MyA4LjE5MjMxWiIgZmlsbD0iIzU1NTI0OSIvPgo8cGF0aCBkPSJNMTQuOTA5MyAxNC41MTdMMTQuMzk2NSAxMi44MDc2TDEwLjQ2NDggMTUuNzEzNkwxNC45MDkzIDE0LjUxN1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgTrustpilot as ReactComponent };